module.exports = __webpack_public_path__ + "static/media/navigation_stadtbusse_placeholder.5900151d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/navigation_stadtbusse_placeholder.png
// module id = 1469
// module chunks = 0